// extracted by mini-css-extract-plugin
export default {"container":"TournamentsScreensCreator_container"};